// src/hooks/useCharacterActivity.ts

import {useState, useEffect} from "react";
import {doc, onSnapshot} from "firebase/firestore";
import {firestore} from "../services/firebase/config";

export interface Activity {
  type: string;
  description: string;
  timestamp: any;
  experienceGained?: number;
  mementoTokensGained?: number;
  downtimeDaysSpent?: number;
}

export interface CharacterActivity {
  characterId: string;
  playerId: string;
  activities: Activity[];
  createdAt: any;
  updatedAt: any;
}

export const useCharacterActivity = (characterId: string | null) => {
  const [activity, setActivity] = useState<CharacterActivity | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!characterId) {
      setActivity(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    const docRef = doc(firestore, "characterActivity", characterId);

    const unsubscribe = onSnapshot(
      docRef,
      (docSnap) => {
        if (docSnap.exists()) {
          setActivity(docSnap.data() as CharacterActivity);
        } else {
          setActivity(null);
        }
        setLoading(false);
      },
      (err) => {
        console.error("Error fetching character activity:", err);
        setError(err.message);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [characterId]);

  return {activity, loading, error};
};
